export enum LaftStatus {
  Pending = 'pending',
  InProgress = 'in progress',
  InReview = 'in review',
  PepRequested = 'pep requested',
  SignatureRequested = 'signature requested',
  Signed = 'signed',
  Completed = 'completed',
  Error = 'error',
}
